//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowZoom(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 2L14 4H18.59L14.29 8.29L15.71 9.71L20 5.41V10L22 8V2H16Z" fill="currentColor" /><path d="M2 2V8L4 10V5.41L8.29 9.71L9.71 8.29L5.41 4H10L8 2H2Z" fill="currentColor" /><path d="M20 18.59L15.71 14.29L14.29 15.71L18.59 20H14L16 22H22V16L20 14V18.59Z" fill="currentColor" /><path d="M9.71 15.71L8.29 14.29L4 18.59V14L2 16V22H8L10 20H5.41L9.71 15.71Z" fill="currentColor" /></svg>;
}
export default IconArrowZoom;